var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { LayoutComponentDisplay } from "@/components/forms/components/layout/layoutComponentDisplay";
import { FieldViewType, screenViewType } from "@/components/fields/viewType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faPaperPlaneTop, } from "@fortawesome/pro-regular-svg-icons";
import { useGenerateUserPasswordMutation, useLoadSystemConfigurationsQuery, useSaveRecordMutation, useSaveUploadedFileMutation, useTestInboundEmailConnectionMutation, } from "@/store/api";
import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import copy from "fast-copy";
import { LoaderImage } from "@/utils/loader";
import { validateRecord, } from "@/utils/validations/validationRules";
import "@/utils/validations/rules";
import { useLogger } from "@/utils/loggerService";
import { mapFieldMetaData } from ".";
import { UserProfile } from "./users/userProfile";
import { useTranslation } from "react-i18next";
import SchedulerInvites from "./activities/schedulerInvites";
import { useAppSelector } from "@/hooks/store";
import { getCurrentUser, getCurrentUserDateFormat, getCurrentUserTimeFormat, } from "@/store/utils/selectors/userSelector";
import { AORReports } from "./aor_reports/edit";
import InboundEmailEdit from "@/pages/inboundEmail/editView";
import { get_current_language } from "@/components/forms/components/utils";
import { faUndo } from "@fortawesome/pro-solid-svg-icons";
import { isEqual } from "lodash";
function ModuleEdit(_a) {
    var _this = this;
    var _b, _c, _d;
    var widget = _a.widget;
    var logger = useLogger().logger;
    var location = useLocation();
    var t = useTranslation(["common", "Users", "InboundEmail"]).t;
    var queryParams = new URLSearchParams(location.search);
    var typeSearch = queryParams.get("type");
    var parent_module = queryParams.get("parent_module");
    var module = (widget === null || widget === void 0 ? void 0 : widget.payload.module) || "";
    var layoutMeta = (widget === null || widget === void 0 ? void 0 : widget.payload.view_defs) || [];
    var field_defs = (widget === null || widget === void 0 ? void 0 : widget.payload.field_defs) || [];
    var record = (widget === null || widget === void 0 ? void 0 : widget.payload.record) || [];
    var isPreview = (widget === null || widget === void 0 ? void 0 : widget.payload.isPreview) || false;
    var viewType = FieldViewType.EDIT;
    var view = (widget === null || widget === void 0 ? void 0 : widget.payload.view) || screenViewType.EDITVIEW;
    var dateFormat = useAppSelector(getCurrentUserDateFormat);
    var timeFormat = useAppSelector(getCurrentUserTimeFormat);
    var currentUser = useAppSelector(getCurrentUser);
    var format = "DD/MM/yyyy HH:mm";
    var dateTimeFormat = useMemo(function () { return "".concat(dateFormat, " ").concat(timeFormat) || format; }, [format, dateFormat, timeFormat]);
    var hiddenDataFromSubpanel = location.state;
    var _e = hiddenDataFromSubpanel || {}, relatedId = _e.relatedId, relatedModuleName = _e.relatedModuleName;
    var navigate = useNavigate();
    var _f = useState(false), isLoad = _f[0], setIsLoad = _f[1];
    var _g = useState(copy(record)), editedRecord = _g[0], setEditedRecord = _g[1];
    var _h = useState({
        user: [],
        contact: [],
        lead: [],
    }), invitees = _h[0], setInvitees = _h[1];
    var _j = useState(new Map()), validations = _j[0], setValidations = _j[1];
    var updateRecord = function (edited) {
        if (module === "OutboundEmailAccounts") {
            edited = __assign(__assign({}, edited), { type: editedRecord.type });
        }
        setEditedRecord(function (prev) { return (__assign(__assign({}, prev), edited)); });
    };
    useEffect(function () {
        var initialRecord = __assign({}, record);
        if (!(record === null || record === void 0 ? void 0 : record.id) &&
            module === "OutboundEmailAccounts" &&
            typeSearch !== null) {
            initialRecord.type = typeSearch === "group" ? "system" : "user";
        }
        setEditedRecord(initialRecord);
    }, [record, module, typeSearch]);
    var _k = mapFieldMetaData(layoutMeta.layout, field_defs), filteredFieldsDefs = _k[0], fieldMetadataMap = _k[1];
    var validationRules = useMemo(function () {
        var validationRules = new Map();
        fieldMetadataMap.forEach(function (field, fieldName) {
            var controls = field.type === undefined || field.type === ""
                ? []
                : fieldName === "email1"
                    ? "email"
                    : field.type;
            var rules = Array.isArray(controls) ? controls : [controls];
            if (field.required && !["boolean"].includes(field.type || "")) {
                rules.push("mandatory");
            }
            var er = /^-?[0-9]+$/;
            if (field.len && er.test(field.len)) {
                rules.push("max:".concat(field.len));
            }
            if (field.validation && field.validation.type === "isbefore") {
                var safeDateTimeFormat = (dateTimeFormat || "").replace(/:/g, "_");
                rules.push("isbefore:".concat(field.validation.compareto, ":").concat(safeDateTimeFormat));
            }
            if (field.validation && field.validation.type === "function") {
                rules.push("function");
            }
            if (field.validation && field.validation.type === "range") {
                rules.push("between:".concat(field.validation.min, ":").concat(field.validation.max));
            }
            if (rules.length <= 0) {
                return;
            }
            validationRules.set(fieldName, rules);
        });
        return validationRules;
    }, [fieldMetadataMap]);
    var validate = useCallback(function () {
        var result = validateRecord(editedRecord, fieldMetadataMap, validationRules, t);
        setValidations(result);
        return result;
    }, [editedRecord, fieldMetadataMap, setValidations, t, validationRules]);
    var childRef = useRef(null);
    var _l = useState({}), errors = _l[0], setErrors = _l[1];
    var _m = useLoadSystemConfigurationsQuery(null), systemData = _m.data, error = _m.error;
    var systemConfig = (systemData === null || systemData === void 0 ? void 0 : systemData.data) || {};
    var isGeneratedPwdOn = (_b = systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.passwordSettings) === null || _b === void 0 ? void 0 : _b.SystemGeneratedPasswordON;
    var username = editedRecord === null || editedRecord === void 0 ? void 0 : editedRecord.user_name;
    var useremail = editedRecord === null || editedRecord === void 0 ? void 0 : editedRecord.email1;
    var defaultLanguage = get_current_language() || ((_c = systemConfig.languages) === null || _c === void 0 ? void 0 : _c.default);
    var sendGenerateUserPassword = useGenerateUserPasswordMutation()[0];
    var doSendEmailGeneratePassword = function () { return __awaiter(_this, void 0, void 0, function () {
        var result, res, data, message, status_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sendGenerateUserPassword({
                            username: username,
                            useremail: useremail,
                            userLang: defaultLanguage,
                        })];
                case 1:
                    result = _a.sent();
                    res = result.data || {};
                    data = res.data || {};
                    message = data.message || "";
                    status_1 = data.status || 0;
                    if (status_1 === 1) {
                        toast.success("Email envoyé.");
                    }
                    else {
                        toast.error(message);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var _o = useState(), displayValidationResult = _o[0], setDisplayvalidationResult = _o[1];
    var saveRecordMutaion = useSaveRecordMutation()[0];
    var saveRecord = function (sendInvites) {
        if (sendInvites === void 0) { sendInvites = 0; }
        return __awaiter(_this, void 0, void 0, function () {
            var validationResult, result_1, finalRecord, body, result, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        validationResult = validate();
                        setDisplayvalidationResult(validationResult);
                        if (module === "InboundEmail") {
                            result_1 = (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.validateForm();
                            if (!(result_1 === null || result_1 === void 0 ? void 0 : result_1.valid)) {
                                setErrors(result_1.errors);
                                return [2 /*return*/];
                            }
                        }
                        if (module === "Users" &&
                            !(isAdminCreation && !isGeneratedPwdOn) &&
                            errorPassText.length > 0) {
                            return [2 /*return*/];
                        }
                        if (validationResult.size > 0) {
                            logger.error("L'enregistrement ne peut \u00EAtre enregistr\u00E9 tant qu'il y a des erreurs au niveau des champs.");
                            logger.error("Erreur validation", validationResult);
                            return [2 /*return*/];
                        }
                        setDisplayvalidationResult(null);
                        setIsLoad(true);
                        if (editedRecord.filecontents) {
                            saveUploadedFile();
                        }
                        finalRecord = __assign({}, editedRecord);
                        if (isAdminCreation && !isGeneratedPwdOn) {
                            delete finalRecord.password;
                        }
                        body = __assign({ module: module, sendInvites: sendInvites, invitees: invitees, record: finalRecord }, (relatedId &&
                            relatedModuleName && {
                            relatedId: relatedId,
                            relatedModuleName: relatedModuleName,
                        }));
                        return [4 /*yield*/, saveRecordMutaion({ body: body })];
                    case 1:
                        result = _b.sent();
                        if (!(module === "Users" && !isGeneratedPwdOn)) return [3 /*break*/, 3];
                        return [4 /*yield*/, doSendEmailGeneratePassword()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        if (result.data.data.error.length > 0) {
                            setIsLoad(false);
                            setHasError(true);
                            setPassError(result.data.data.error);
                            navigate("/modules/".concat(module, "/EditView/").concat(result.data.data.bean));
                        }
                        else if (module === "InboundEmail") {
                            navigate("/modules/".concat(module));
                        }
                        else if (result.data.data.bean.length > 0) {
                            toast.success("Enregistrement terminé.");
                            setIsLoad(false);
                            navigate("/modules/".concat(module, "/DetailView/").concat(result.data.data.bean));
                        }
                        else {
                            if (relatedId && relatedModuleName) {
                                navigate("/modules/".concat(relatedModuleName, "/DetailView/").concat(relatedId));
                            }
                            else {
                                navigate("/modules/".concat(module));
                            }
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _b.sent();
                        setIsLoad(false);
                        console.log(error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var elemId = isPreview ? "previewDetailForm" : "detailForm";
    var saveUploadedFileMutation = useSaveUploadedFileMutation()[0];
    var saveUploadedFile = function () { return __awaiter(_this, void 0, void 0, function () {
        var filebase, fileName, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filebase = (editedRecord.filecontents &&
                        editedRecord.filecontents["base64String"]) ||
                        "";
                    fileName = (editedRecord.filecontents && editedRecord.filecontents["fileName"]) ||
                        "";
                    return [4 /*yield*/, saveUploadedFileMutation({
                            body: {
                                record: editedRecord,
                                filename: fileName,
                                fileuploaded: filebase,
                                remove: false,
                                module: module,
                            } || {},
                        })];
                case 1:
                    response = _a.sent();
                    if (response.payload === "ko") {
                        alert("Il y a une erreur lors de l'enregistrement du fichier.");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var _p = useState([]), passSettings = _p[0], setPassSettings = _p[1];
    var _q = useState(""), errorPassText = _q[0], setErrorPassText = _q[1];
    var isAdminCreation = module === "Users" && ((_d = currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes) === null || _d === void 0 ? void 0 : _d.is_admin) && !(record === null || record === void 0 ? void 0 : record.id);
    var getPasswordValue = function (value) {
        if (isAdminCreation && !isGeneratedPwdOn)
            return;
        setPassSettings(value);
        setEditedRecord(__assign(__assign({}, editedRecord), { password: value }));
    };
    var getAdvancedSettings = function (value) {
        setEditedRecord(__assign(__assign({}, editedRecord), { advanced: value }));
    };
    useEffect(function () {
        if (isAdminCreation && !isGeneratedPwdOn) {
            setErrorPassText("");
            return;
        }
        setErrorPassText(validatePassword(passSettings, t, isAdminCreation));
    }, [passSettings]);
    var _r = useState(false), hasError = _r[0], setHasError = _r[1];
    var _s = useState(""), passError = _s[0], setPassError = _s[1];
    // Validation via touche entrée du clavier
    useEffect(function () {
        window.addEventListener("keypress", keyPressSave);
        return function () { return window.removeEventListener("keypress", keyPressSave); };
    }, [editedRecord]);
    var keyPressSave = function (_a) {
        var key = _a.key;
        key === "Enter" && saveRecord();
    };
    var updateInvites = function (value) {
        var idsUsers = [];
        var idsContacts = [];
        var idsLeads = [];
        var UsersInvites = value
            .filter(function (item) {
            return item.module_name === "Users";
        })
            .map(function (item) { return idsUsers.push(item.id); });
        var ContactsInvites = value
            .filter(function (item) {
            return item.module_name === "Contacts";
        })
            .map(function (item) { return idsContacts.push(item.id); });
        var LeadsInvites = value
            .filter(function (item) {
            return item.module_name === "Leads";
        })
            .map(function (item) { return idsLeads.push(item.id); });
        setInvitees({ user: idsUsers, lead: idsLeads, contact: idsContacts });
    };
    var _t = useState(false), showPopup = _t[0], setShowPopup = _t[1];
    var testSettingsConnection = useTestInboundEmailConnectionMutation()[0];
    var _u = useState(""), messageTest = _u[0], setMessageTest = _u[1];
    var testInboundSettings = function () { return __awaiter(_this, void 0, void 0, function () {
        var body, result, error_3;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    setIsLoad(true);
                    body = {
                        server_url: editedRecord.server_url,
                        protocol: editedRecord.protocol,
                        port: editedRecord.port,
                        ssl: editedRecord.ssl === "1" ? "true" : "false",
                        email_user: editedRecord.email_user,
                        email_password: editedRecord.email_password,
                        mailbox: editedRecord.mailbox,
                    };
                    return [4 /*yield*/, testSettingsConnection({ body: body })];
                case 1:
                    result = _e.sent();
                    if (((_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.success) === false) {
                        setIsLoad(false);
                        setShowPopup(true);
                        setMessageTest((_d = (_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _e.sent();
                    console.log(error_3);
                    setIsLoad(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var isEmptyValue = function (value) {
        if (value === null || value === undefined || value === "")
            return true;
        if (Array.isArray(value) && value.length === 0)
            return true;
        if (typeof value === "object" &&
            !Array.isArray(value) &&
            Object.keys(value).length === 0)
            return true;
        return false;
    };
    var normalize = function (obj, keys) {
        var clean = {};
        keys.forEach(function (key) {
            var value = obj === null || obj === void 0 ? void 0 : obj[key];
            if (isEmptyValue(value)) {
                clean[key] = "";
            }
            else if (typeof value === "number") {
                clean[key] = String(value);
            }
            else {
                clean[key] = value;
            }
        });
        return clean;
    };
    var hasChanges = useMemo(function () {
        var allKeys = Array.from(new Set(__spreadArray(__spreadArray([], Object.keys(record || {}), true), Object.keys(editedRecord || {}), true)));
        var a = normalize(record, allKeys);
        var b = normalize(editedRecord, allKeys);
        var diff = allKeys.filter(function (k) { return !isEqual(a[k], b[k]); });
        return diff.length > 0;
    }, [record, editedRecord]);
    var _v = useState(false), isSaveHovering = _v[0], setIsSaveHovering = _v[1];
    var _w = useState(false), isUndoHovering = _w[0], setIsUndoHovering = _w[1];
    var _x = useState(false), isSendHovering = _x[0], setIsSendHovering = _x[1];
    var handleSaveMouseOver = function () {
        setIsSaveHovering(true);
    };
    var handleSaveMouseOut = function () {
        setIsSaveHovering(false);
    };
    var handleUndoMouseOver = function () {
        setIsUndoHovering(true);
    };
    var handleUndoMouseOut = function () {
        setIsUndoHovering(false);
    };
    var handleSendMouseOver = function () {
        setIsSendHovering(true);
    };
    var handleSendMouseOut = function () {
        setIsSendHovering(false);
    };
    var _y = useState(0), formVersion = _y[0], setFormVersion = _y[1];
    var rollbackChanges = useCallback(function () {
        var initial = copy(record);
        setEditedRecord(initial);
    }, [record]);
    var handleRollback = function () {
        rollbackChanges();
        setDisplayvalidationResult("");
        setValidations("");
        setFormVersion(function (v) { return v + 1; });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "relative bg-[var(--colors-bg-default)] rounded-md m-2", id: elemId }, { children: [_jsxs("div", __assign({ className: "border-b-2 py-4" }, { children: [hasError && (_jsxs("div", __assign({ className: "bg-[rgb(var(--color-red-400))] p-3 m-2 rounded-md " }, { children: [_jsx("span", __assign({ className: "text-white p-5 text-sm font-medium" }, { children: "Erreur lors de la sauvegarde." })), _jsx("div", __assign({ className: "px-5 text-sm text-white font-medium" }, { children: passError }))] }))), displayValidationResult && (_jsxs("div", __assign({ className: "bg-[rgb(var(--color-red-400))] p-3 m-2 rounded-md " }, { children: [_jsx("span", __assign({ className: "text-white p-5 text-sm font-medium" }, { children: "You have errors in your form. Try to resolve them before saving." })), _jsx("ul", __assign({ className: "px-5 text-sm text-white font-medium" }, { children: Array.from(displayValidationResult).map(function (_a) {
                                            var key = _a[0], value = _a[1];
                                            return (_jsxs("li", { children: [t(filteredFieldsDefs[key].vname, {
                                                        ns: module,
                                                    }), _jsx("span", __assign({ className: "p-1" }, { children: value }))] }, key));
                                        }) })), errorPassText.length > 0 && (_jsx("div", __assign({ className: "px-5 text-sm text-white font-medium" }, { children: errorPassText })))] }))), ((record === null || record === void 0 ? void 0 : record.id) || (editedRecord === null || editedRecord === void 0 ? void 0 : editedRecord.name)) && (_jsx("div", __assign({ className: "flex flex-row items-center ml-2 px-2" }, { children: _jsxs("div", __assign({ className: "bg-[var(--colors-widget)] flex flex-row ml-4 mt-6 p-2" }, { children: [_jsx("h1", __assign({ className: "uppercase text-[var(--colors-label)] p-1" }, { children: (editedRecord === null || editedRecord === void 0 ? void 0 : editedRecord.name) || (record === null || record === void 0 ? void 0 : record.name) })), hasChanges && (_jsxs(_Fragment, { children: [_jsxs("button", __assign({ className: "hover:bg-red-500 text-red-500 font-bold hover:text-white rounded-md p-1", onMouseOver: handleSaveMouseOver, onMouseOut: handleSaveMouseOut, onClick: function () { return saveRecord(); } }, { children: [_jsx(FontAwesomeIcon, { icon: faFloppyDisk, className: "px-2" }), isSaveHovering && (_jsx("label", __assign({ className: "text-white px-2" }, { children: String(t("app.LBL_SAVE_BUTTON_LABEL", { ns: "common" })) })))] })), _jsxs("button", __assign({ className: "hover:bg-red-500 text-red-500 font-bold hover:text-white rounded-md p-1", onMouseOver: handleUndoMouseOver, onMouseOut: handleUndoMouseOut, onClick: function () {
                                                        handleRollback();
                                                    } }, { children: [_jsx(FontAwesomeIcon, { icon: faUndo, className: "px-2" }), isUndoHovering && (_jsx("label", __assign({ className: "text-white px-2" }, { children: String(t("app.LBL_CANCEL_BUTTON_LABEL", { ns: "common" })) })))] }))] })), (module === "Meetings" || module === "Calls") && (_jsxs("button", __assign({ className: "hover:bg-gray-300 font-bold rounded-md p-1", onMouseOver: handleSendMouseOver, onMouseOut: handleSendMouseOut, onClick: function () {
                                                saveRecord(1);
                                            } }, { children: [_jsx(FontAwesomeIcon, { icon: faPaperPlaneTop, className: "text-gray-400 hover:text-white hover:bg-gray-300  px-2 dark:text-black" }), isSendHovering && (_jsx("label", __assign({ className: "text-white px-2" }, { children: String(t("LBL_SEND_INVITES", { ns: "Home" })) })))] })))] })) }))), module === "InboundEmail" && (_jsx("span", __assign({ className: "ml-2" }, { children: _jsx("button", __assign({ className: "button primary", onClick: function () {
                                        testInboundSettings();
                                    } }, { children: t("LBL_TEST_SETTINGS", { ns: "InboundEmail" }) })) }))), showPopup && (_jsx("div", __assign({ className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" }, { children: _jsxs("div", __assign({ className: "bg-white rounded-2xl shadow-lg p-6 w-1/5 flex flex-col items-center" }, { children: [_jsx("div", __assign({ className: "mb-4 text-center" }, { children: _jsx("label", __assign({ className: "text-sm font-medium" }, { children: messageTest })) })), _jsx("button", __assign({ className: "bg-[var(--colors-widget)] text-white p-1 border rounded-sm", onClick: function () { return setShowPopup(false); } }, { children: t("app.LBL_CLOSEINLINE", { ns: "common" }) }))] })) })))] })), module === "Users" ? (_jsx(UserProfile, { module: module, viewType: viewType, field_defs: field_defs, record: record, layoutMeta: layoutMeta || [], view: view, setRecord: updateRecord, passwordValue: getPasswordValue, advancedSettings: getAdvancedSettings, layoutPwdCreation: isGeneratedPwdOn }, formVersion)) : module === "AOR_Reports" ? (_jsx("div", { children: _jsx(AORReports, { module: module, viewType: viewType, field_defs: field_defs, record: editedRecord, layoutMeta: layoutMeta || [], view: view, setRecord: updateRecord }, formVersion) })) : module === "InboundEmail" ? (_jsx("div", { children: _jsx(InboundEmailEdit, { ref: childRef, record: editedRecord, setRecord: updateRecord, errors: errors }, formVersion) })) : (_jsx("div", { children: _jsx(LayoutComponentDisplay, { module: module, viewType: viewType, fieldDefs: field_defs, record: editedRecord, fetchedRecord: record, layouts: (layoutMeta === null || layoutMeta === void 0 ? void 0 : layoutMeta.layout) || [], onHandleUpdate: updateRecord, validations: validations, viewScreen: view }, formVersion) })), isLoad && _jsx(LoaderImage, {})] })), (module === "Meetings" || module === "Calls") && (_jsx(SchedulerInvites, { updateInvitees: updateInvites, record: editedRecord, module: module }, formVersion))] }));
}
widgetsDictionary.register("widget/module/edit", {
    name: "Module Edition",
    display: ModuleEdit,
    selectable: false,
});
export var validatePassword = function (data, t, isAdminCreation) {
    if (isAdminCreation === void 0) { isAdminCreation = false; }
    var error = "";
    if (isAdminCreation) {
        if (!data.new || !data.confirm) {
            return t("LBL_NEW_PASSWORD", { ns: "Users" });
        }
        if (data.new !== data.confirm) {
            return t("ERR_PASSWORD_MISMATCH", { ns: "Users" });
        }
        return "";
    }
    if ((data.new === "" || data.confirm === "") && data.old !== "") {
        error = t("LBL_NEW_PASSWORD", { ns: "Users" });
    }
    else if ((data === null || data === void 0 ? void 0 : data.confirm) !== "" &&
        (data === null || data === void 0 ? void 0 : data.new) !== "" &&
        data.new !== data.confirm) {
        error = t("ERR_PASSWORD_MISMATCH", { ns: "Users" });
    }
    else if (!isAdminCreation &&
        data.old === "" &&
        (data.new !== "" || data.confirm !== "")) {
        error = t("LBL_OLD_PASSWORD", { ns: "Users" });
    }
    else {
        error = "";
    }
    return error;
};
